import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserService = sdk.getService('UserService');

export const useCompleteProfilePercentage = () => {
  const { data: completeProfilePercentage, isPending } = useQuery({
    queryKey: ['complete-profile-percentage'],
    queryFn: () => UserService.getCompleteProfilePercentage()
  });

  return {
    completeProfilePercentage,
    isPending
  };
};
